export class ProcedimentoConflitoDTO {

    idProcedimento: number = 0;

    nomeProcedimento: string = '';

    idConflito: number = 0;

    nomeConflito: string = '';

    tempoConflito: number = 0;

    constructor() {
    }
}
